import * as React from "react";
import LandingPageComponent from "./landingpage.component";

class MainComponent extends React.Component {
  render(): JSX.Element {
    return (
      <div>
        <LandingPageComponent />
      </div>
    );
  }
}

export default MainComponent;



// WEBPACK FOOTER //
// ./src/components/main.component.tsx